var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 66,
    viewBox: "0 0 50 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.58143 0H33.6765L49.9197 16.5407V61.4031C49.9197 63.9615 47.8373 65.9845 45.3383 65.9845H4.58143C2.02297 65.9845 0 63.9615 0 61.4031V4.64093C0 2.08247 2.02297 0 4.58143 0Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9197 16.5407H37.8414C35.5209 16.5407 33.6169 14.6368 33.6169 12.3163V0H33.6764L49.9197 16.5407Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9198 16.5408V28.6786L38.02 16.5408H49.9198Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8741 39H6.12593C4.95181 39 4 39.9485 4 41.1185V58.8815C4 60.0515 4.95181 61 6.12593 61H43.8741C45.0482 61 46 60.0515 46 58.8815V41.1185C46 39.9485 45.0482 39 43.8741 39Z",
    fill: "#5D6569"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3511 53.5928V54.9531H33.0669V53.5928H38.3511ZM33.5522 45V54.9531H31.8364V45H33.5522ZM37.6606 49.1562V50.4961H33.0669V49.1562H37.6606ZM38.3169 45V46.3672H33.0669V45H38.3169Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3101 53.5928V54.9531H25.313V53.5928H30.3101ZM25.7915 45V54.9531H24.0757V45H25.7915Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7429 45V54.9531H20.0271V45H21.7429Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7158 45V54.9531H12V45H13.7158ZM17.7764 49.3545V50.7148H13.2783V49.3545H17.7764ZM18.3438 45V46.3672H13.2783V45H18.3438Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/FILE.b19219877494816acaec008f9a52e138.svg";
export { ForwardRef as ReactComponent };